import { gsap } from "gsap";

export default {
	name: 'default',
	leave({ current, next, trigger }) {
		return new Promise(resolve => {

			gsap.set(document.querySelector('[data-default-transition]'), {
				opacity: 1,
				transformOrigin: 'bottom'
			});

			gsap.to(document.querySelector('[data-default-transition]'), {
				scaleY: 1,
				ease: 'power3.inOut',
				duration: 1,
				onComplete: () => {
					resolve();
				},
			});
		});
	},
	afterLeave({ current, next, trigger }) {
		return new Promise(resolve => {

			gsap.set(current.container, {
				opacity: 0,
			});

			next.container.classList.add('default-transition-absolute');

			window.dispatchEvent(new CustomEvent('close-menu'));

			document.body.classList.remove('body--inverted');
			document.body.classList.remove('body--header-inverted');

			resolve();

		});
	},
	beforeEnter({ current, next, trigger }) {
		return new Promise(resolve => {

			gsap.set(document.querySelector('[data-default-transition]'), {
				transformOrigin: 'top'
			});

			gsap.to(document.querySelector('[data-default-transition]'), {
				scaleY: 0,
				ease: 'power3.inOut',
				duration: 1.2,
				onStart: () => {
					window.scrollTo(0, -1);
				},
				onComplete: () => {
					resolve();
				},
			});

		});
	},
	after({ current, next, trigger }) {
		next.container.classList.remove('default-transition-absolute');
	},
};
